import { useAuth } from '@/auth/AuthContext';
import RestUsage from '@/pages/versions/RestUsage';
import { setActiveUrl } from '@/redux/reducer';
import { RootState } from '@/typings';
import { ElAvatar, ElButton, ElDivider, ElIcon, ElPopover } from '@qsxy/element-plus-react';
import { TooltipRef } from '@qsxy/element-plus-react/dist/Tooltip/typings';
import { useMemoizedFn } from 'ahooks';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './header.scss';

const Header = () => {
	const { signOut } = useAuth();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const logout = useMemoizedFn(() => signOut(navigate));
	const loginUser = useSelector<RootState, RootState['user']>(state => state.user ?? {});

	const tooltipRef = useRef<TooltipRef>(null);

	return (
		<>
			<header className="ttn-layout-header">
				<div className="ttn-topbar">
					<div className="ttn-topbar-left">
						{
							<div className="ttn-welcome-text">
								<div>欢迎使用碳中和行业大模型</div>
							</div>
						}
					</div>

					<div className="ttn-topbar-right">
						<span className="ttn-action">
							<span className="ttn-header-notice">
								{!loginUser || loginUser?.isVisitor ? (
									// <ElButton type="primary" text block icon="arrow-right" onClick={() => navigate('/login')}>
									// 	已有账号？去登录
									// </ElButton>
									<span className="ttn-header-notice">
										<ElButton type="warning" icon="bolt" iconProps={{ prefix: 'fas' }} onClick={() => navigate('/register')}>
											免费注册
										</ElButton>
										<ElButton type="info" text onClick={() => navigate('/login')}>
											登录
										</ElButton>
									</span>
								) : (
									<ElPopover
										ref={tooltipRef}
										trigger="hover"
										width={240}
										placement="bottom-end"
										className="ttn-user-poppover"
										content={
											<>
												<div className="user-banner">{loginUser?.username}</div>
												<ElDivider style={{ '--el-divider-margin': '12px -10px 12px 0px' }} />
												<ElButton
													type="info"
													text
													block
													icon="user"
													iconProps={{ prefix: 'fas' }}
													onClick={() => {
														dispatch(setActiveUrl('settings'));
														navigate('/setting/userInfo');
														tooltipRef.current.hide();
													}}
												>
													用户设置
												</ElButton>

												{/* <ElButton
													type="info"
													text
													block
													icon="share-nodes"
													iconProps={{ prefix: 'fas' }}
													onClick={() => {
														dispatch(setActiveUrl('shareList'));
														navigate('/shareList');
														tooltipRef.current.hide();
													}}
												>
													我的邀请
												</ElButton> */}
												<ElDivider style={{ '--el-divider-margin': '12px -10px 12px 0px' }} />
												<ElButton type="danger" text block icon="arrow-right-from-bracket" onClick={logout}>
													退出
												</ElButton>
											</>
										}
										style={{ '--el-popover-padding': '10px' }}
									>
										<ElAvatar size={40} src="undefined" style={{ '--el-avatar-bg-color': '#f5f5f5' }}>
											{loginUser?.avatar ? <img src={loginUser.avatar} style={{ width: '100%' }} /> : <ElIcon name="user" prefix="fas" />}
										</ElAvatar>
									</ElPopover>
								)}
							</span>
						</span>
					</div>
				</div>
			</header>
		</>
	);
};

export default Header;
